import {Injectable} from '@angular/core';
import {TenantService} from './tenant.service';
import {from as fromPromise, Observable} from 'rxjs';
import {readDocumentValue} from '../common/firestore-utils';
import {first, map} from 'rxjs/operators';
import { doc, docData, Firestore, setDoc } from '@angular/fire/firestore';
import { DomSanitizer } from '@angular/platform-browser';
import { HtmlSanitizerUtil } from '../common/html-sanitizer.util';


@Injectable()
export class DescriptionsDbService {

  constructor(
    private tenant: TenantService,
    private firestore: Firestore,
    private sanitizer: DomSanitizer
  ) {}

  loadDescription(descriptionId: string): Observable<string> {
    const descriptionData = docData(doc(this.firestore, this.descriptionsPath + '/' + descriptionId), {idField: 'id'})

    return readDocumentValue<Object>(descriptionData)
      .pipe(
        map(val => val ? val['description'] : undefined),
        first()
      );
  }

  saveDescription(descriptionId:string, description: string): Observable<string> {
    // Sanitize HTML before saving to prevent XSS attacks
    const sanitizedDescription = HtmlSanitizerUtil.sanitizeHtml(this.sanitizer, description);

    const saveDescriptionDocRef = doc(this.firestore, this.descriptionsPath, descriptionId)

    const saveDescriptionDocAsync = setDoc(saveDescriptionDocRef, {description: sanitizedDescription})

    return fromPromise(saveDescriptionDocAsync)
      .pipe(
        map(() => {
          return sanitizedDescription;
        })
      );
  }

  private get descriptionsPath() {
    return this.tenant.path('descriptions');
  }

}
